<template>
  <div class="learingCourseClass">
      <backHeader back-addr="/index"></backHeader>
      <div tyle="width:100%;height:240px;">
        <div id="map" style="width:100%;height:240px;"></div>
      </div>
      <ul>
        <li v-for="item in types"  @click="goType(item.id)" style="text-align:left;font-size:16px;padding-left:10px;background:white;"><span style="line-height:40px;font-size:16px;">{{item.name}}</span><crossLine></crossLine></li>
      </ul>
      <div style="height:50px;"></div>
  </div>
</template>
<script>

import Vue from "vue";

import openUrl from "./../utils/openUrl";

import crossLine from "./../components/cross-line.vue";
import backHeader from "./../components/back-header.vue";
import commonHeader from "./../components/common-header.vue";
// import IndexApi from '../api/learingInd.js'
import cfg from "./../utils/config";
import axios from "axios";
import Addr from "./../utils/getAPI";
import store from "@/store/index";
import { Toast } from "mint-ui";

export default {
  name: "learingCourseClass",
  data() {
    return {
      types: [
        {
          name: "习近平新时代中国特色社会主义思想专题辅导课",
          id: "1"
        },
        {
          name: "毛泽东思想和中国特色社会主义体系概论",
          id: "2"
        },
        {
          name: "中国近现代史纲要",
          id: "3"
        },
        {
          name: "思想道德修养与法律基础",
          id: "4"
        },
        // {
        //   name: "形势与政策",
        //   id: "5"
        // },
        {
          name: "马克思主义基本原理概论",
          id: "6"
        }
      ],
      schools: [
        {
          name: "黑龙江大学",
          longitude: 126.6098074615002,
          latitude: 45.70441106160182,
          link: this.linkPre,
          img: require("./img/ne/school5.png")
          // img: "school5"
        },
        {
          name: "哈尔滨工业大学",
          longitude: 126.62674795836212,
          latitude: 45.74561261587106,
          link: this.linkPre,
          img: require("./img/ne/school3.png")
          // img: "school3"
        },
        {
          name: "哈尔滨理工大学",
          longitude: 126.60851262509824,
          latitude: 45.71157352059364,
          link: this.linkPre,
          img: require("./img/ne/school6.png")
          // img: "school6"
        },
        {
          name: "东北林业大学",
          longitude: 126.63424037396909,
          latitude: 45.71693727163749,
          link: this.linkPre,
          img: require("./img/ne/school2.png")
          // img: "school2"
        },
        {
          name: "哈尔滨医科大学",
          longitude: 126.61389850080013,
          latitude: 45.69949570522716,
          link: this.linkPre,
          img: require("./img/ne/school1.png")
          // img: "school1"
        },
        {
          name: "哈尔滨工程大学",
          longitude: 126.67619012296201,
          latitude: 45.773779342881866,
          link: this.linkPre,
          img: require("./img/ne/school7.png")
          // img: "school7"
        },
        {
          name: "东北农业大学",
          longitude: 126.7229249328375,
          latitude: 45.74025910564071,
          link: this.linkPre,
          img: require("./img/ne/school4.png")
          // img: "school4"
        }
      ],
  
      heightSize: 160,

      imgBaseUrl: cfg.imgBaseUrl,
    
    };
  },
  methods: {
    mapInit() {
      let map = L.map("map", {
        center: [45.74740199642105, 126.65817975997926],
        zoom: 11
      });
      // 影像
      L.tileLayer(
        "http://t{s}.tianditu.com/img_w/wmts?service=wmts&request=GetTile&version=1.0.0&LAYER=img&tileMatrixSet=w&TileMatrix={z}&TileRow={y}&TileCol={x}&style=default&format=tiles&tk=b256e08b9f972a2c4677ab5608a305ff",
        {
          subdomains: ["0", "1", "2", "3", "4", "5", "6", "7"]
        }
      ).addTo(map);
      // 地名标注
      L.tileLayer(
        "http://t{s}.tianditu.com/cia_w/wmts?service=wmts&request=GetTile&version=1.0.0&LAYER=cia&tileMatrixSet=w&TileMatrix={z}&TileRow={y}&TileCol={x}&style=default&format=tiles&tk=b256e08b9f972a2c4677ab5608a305ff",
        {
          subdomains: ["0", "1", "2", "3", "4", "5", "6", "7"]
        }
      ).addTo(map);
      // 边界
      L.tileLayer(
        "http://t{s}.tianditu.com/ibo_w/wmts?service=wmts&request=GetTile&version=1.0.0&LAYER=ibo&tileMatrixSet=w&TileMatrix={z}&TileRow={y}&TileCol={x}&style=default&format=tiles&tk=b256e08b9f972a2c4677ab5608a305ff",
        {
          subdomains: ["0", "1", "2", "3", "4", "5", "6", "7"]
        }
      ).addTo(map);

      let _self = this;

      console.log(_self.schools);

      _self.schools.forEach(item => {
        var linkComponent = Vue.extend({
          // template: '<a @click="goArea('+item.name+','+item.img+')">' + item.name + '</a>',
          template: '<a @click="goArea()">' + item.name + "</a>",
          methods: {
            goArea() {
              console.log("got it");
              _self.$router.push({
                path: "/area",
                query: {
                  name: item.name,
                  img: item.img
                }
              });
            }
          }
        });
        var component = new linkComponent().$mount();

        var name = item.name;
        var marker = L.marker([item.latitude, item.longitude])
          .addTo(map)
          .bindPopup(
            component.$el
            // '<a>' + item.name + '</a>'

            // '<a href="' +
            // item.link +
            // "?name=" +
            // encodeURI(item.name) +
            // "&img=" +
            // item.img +
            // '">' +
            // item.name +
            // "></a>"
          );
      });

    },
   
    goType(id) {
   
      console.log("got it");
      this.$router.push({
        path: "/class",
        query: {
          id: id
        }
      });
    },
    
  },
  created: function() {
    
  },
  mounted: function() {
    
    this.mapInit();
  },
  components: {
    crossLine,
    commonHeader,
    backHeader
  }
};
</script>

<style lang="scss">
@import "../assets/baseScss";
.mint-navbar .mint-tab-item.is-selected {
  color: #e70202 !important;
  border-bottom: 2px solid #e70202 !important;
}

.banner {
  background-size: cover;
  width: 100%;
  min-height: 100%;
}

.learingCourseClass {
  font-weight:bold;
  color:rgb(68, 85, 102)!important;
  .courseItem {
    .item {
      display: flex;
      padding: 15px 15px 0px;

      .ico {
        flex: 1;
        margin-right: 10px;
      }
      .info {
        flex: 2;
        position: relative;
        .tit {
          text-align: left;
          height: 40px;
          line-height: 40px;
          overflow: hidden;
        }
        .speed {
          display: flex;
          font-size: 14px;
          line-height: 30px;
          margin-top: 5px;
          width: 100%;
          a {
            flex: 2;
            color: $cl0;
            text-align: right;
            font-weight: 500;
            i:before {
              position: relative;
              top: 1px;
            }
          }
          .mt-progress {
            flex: 3;
            color: $cl9;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/module-course/index-class.vue